// extracted by mini-css-extract-plugin
export default {"container":"Share_container__iptBe"};